import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInteriorStylinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M9 26h6l1 6H8zM12 32v7"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M8 56v2m8-2v2"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 16,
				x: 5,
				y: 39,
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: 2,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M7 47h10m-6 4h2m-2-8h2"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M16 6h14v10H16z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 19,
				cy: 9,
				r: 1,
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M17 15l3-3 3 1 3-3 3 1"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M29 53h6v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2zm3-8h20V27a4 4 0 0 0-4-4H36a4 4 0 0 0-4 4v18zm17 8h6v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeLinecap: "square",
				strokeLinejoin: "round",
				strokeWidth: 2,
				d: "M34 40h16m3-8h2a4 4 0 0 1 4 4v15a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2V36a4 4 0 0 1 4-4h2"
			})
		]
	})
});
export default SvgInteriorStylinginline;
